import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PlayblastResumeNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M3.8942 1.07579C3.518 1.28909 3.286 1.68749 3.286 2.11989L5.1036 1.09099C4.731 0.868295 4.2704 0.862495 3.8942 1.07579Z"
        fill={color}
      />
      <path
        d="M5.1035 1.09094L3.2859 2.11984V21.88L5.1035 22.9089L21.5695 13.0288V10.971L5.1035 1.09094Z"
        fill={color}
      />
      <path
        d="M3.2859 21.8801C3.2859 22.3125 3.518 22.711 3.8941 22.9242C4.2703 23.1375 4.7308 23.1317 5.1035 22.909L3.2859 21.8801Z"
        fill={color}
      />
      <path
        d="M21.5695 10.9711V13.029C21.9328 12.8122 22.1531 12.4219 22.1531 12.0001C22.1531 11.5783 21.9328 11.1879 21.5695 10.9711Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PlayblastResumeNsk.displayName = 'PlayblastResumeNsk';
